"use client";

import React from "react";
import { Anchor, Crosshair, MapPin, Navigation, Ship } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
const ports = [{
  id: "panama",
  name: "Panama Canal Region",
  x: "25%",
  y: "65%",
  cap1: "Transit Support",
  cap2: "Bunkering Services",
  cap3: "Provisions Coordination",
  description: "Coordinating specialized transit support and connecting vessels with trusted local suppliers at this critical inter-oceanic hub.",
  status: "Active"
}];
export default function StrategicPortPresence() {
  return <section id="strategic-port-presence" className="dark bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[500px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-primary/30 bg-primary/10 text-primary text-xs font-mono uppercase tracking-wider mb-6">
            <Navigation className="w-4 h-4" />
            <span>Global Maritime Network</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold tracking-tight mb-6 text-foreground">
            Strategic Port Presence
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Venchandlers Nexus acts as a strategic broker, coordinating sourcing, quotations, and logistics through a trusted global supplier network across key Atlantic and Caribbean hubs.
          </p>
        </div>

        {}
        <div className="relative w-full aspect-[4/3] md:aspect-[21/9] bg-card/40 border border-border/50 rounded-sm overflow-hidden shadow-2xl backdrop-blur-sm !bg-[url(https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/atlantic_caribbean_blueprint_map.webp)] !bg-[url(https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Vnexus-delivery.png)] !bg-[url(https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Vnexus-delivery.png)] !bg-[url(https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/mapa-hubs.jpg)]">
          
          {}
          <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
          backgroundImage: `linear-gradient(to right, var(--color-border) 1px, transparent 1px), linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }} />
          
          {}
          <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/atlantic_caribbean_blueprint_map.png')] bg-cover bg-center opacity-40 mix-blend-luminosity pointer-events-none" />

          {}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent h-[200%] animate-[spin_10s_linear_infinite] opacity-30 pointer-events-none" style={{
          transformOrigin: 'center'
        }} />

          {}
          {ports.map((port, i) => <div key={port.id} data-index={i} className="absolute z-20 -translate-x-1/2 -translate-y-1/2" style={{
          left: port.x,
          top: port.y
        }}>
              <Popover>
                <PopoverTrigger asChild>
                  <button className="group relative flex items-center justify-center w-8 h-8 outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-full" aria-label={`View details for ${port.name}`}>
                    {}
                    <span className="absolute inset-0 rounded-full bg-primary/40 animate-ping" />
                    
                    {}
                    

                    {}
                    <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 text-xs font-mono text-primary/80 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden md:block bg-background/80 px-2 py-1 border border-primary/20 backdrop-blur-sm">
                      {port.name}
                    </span>
                  </button>
                </PopoverTrigger>
                <PopoverContent className="w-80 bg-card/95 backdrop-blur-md border-border rounded-none border-l-2 border-l-primary shadow-2xl p-0 overflow-hidden" sideOffset={10}>
                  <div className="p-4 border-b border-border/50 bg-muted/30 flex items-start justify-between">
                    <div>
                      <h4 className="font-serif font-bold text-foreground flex items-center gap-2">
                        <MapPin className="w-4 h-4 text-primary" />
                        {port.name}
                      </h4>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                        <span className="text-xs font-mono text-muted-foreground uppercase tracking-wider">Status: {port.status}</span>
                      </div>
                    </div>
                    <Crosshair className="w-5 h-5 text-primary/50" />
                  </div>
                  
                  <div className="p-4 space-y-4">
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {port.description}
                    </p>
                    
                    <div className="space-y-2">
                      <h5 className="text-xs font-mono text-foreground uppercase tracking-wider border-b border-border/50 pb-1 mb-2">
                        Core Capabilities
                      </h5>
                      <ul className="space-y-2">
                        {[port.cap1, port.cap2, port.cap3].map((cap, idx) => <li key={idx} className="flex items-center gap-2 text-sm text-muted-foreground">
                            <Ship className="w-3.5 h-3.5 text-primary" />
                            <span>{cap}</span>
                          </li>)}
                      </ul>
                    </div>
                  </div>
                  
                  <div className="bg-primary/10 p-3 border-t border-primary/20 flex justify-between items-center">
                    <span className="text-xs font-mono text-primary">COORD: {port.x} / {port.y}</span>
                    <Anchor className="w-4 h-4 text-primary" />
                  </div>
                </PopoverContent>
              </Popover>
            </div>)}
        </div>

        {}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground font-mono">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-primary rounded-full shadow-[0_0_10px_var(--color-primary)]" />
            <span>Active Hub</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border border-border flex items-center justify-center">
              <div className="w-1 h-1 bg-border" />
            </div>
            <span>Blueprint Grid</span>
          </div>
        </div>
      </div>
    </section>;
}